<template>
  <div class="chat">
    <div class="chat-window">
      <div class="containerBox" v-show="showChatbot" id="containerBox" :style="{overflowX : 'hidden'}">
        <div class="wrapper">
          <div class="header">
            <img class="botIcon" alt="ChatManaging" src="../assets/VirtualAssistant_Heading-01.png" width="167" height="20">
            <!--CloseButton v-on:click.native="showChatbot = !showChatbot"></CloseButton-->
          </div>
          <div class="sendDiv" style="display: flex;">
            <div class="title" v-show="showFullChat">{{ getCopyConversationText() }}</div>
            <button class="submitButton btn btn-primary" v-show="showFullChat" v-on:click="createEmail()">{{ getCopyConversationButtonLabel() }}</button>
          </div>
          <hr>
          <div class="page-content" ref="scrollBox" :style="{overflowY: showFullChat ? 'scroll' : 'auto', overflowX: showFullChat ? 'hidden' : 'initial', height: showFullChat ? 'calc(100% - 145px)' : 'calc(100% - 100px)'}">
            <IntroForm v-if="showIntro" @submitted="onSubmit" :useEnglishAndFrenchTexts="clientUsesEnglishAndFrenchTranslations()" :introText="getIntroText()" :submitButtonDisabled="submitDisabled"></IntroForm>
            <CloseChatConfirmationModal v-if="showCloseConfirmationModal"
                                        @confirmed="endConversation"
                                        @dismissed="hideCloseConfirmationModal"
                                        :useEnglishAndFrenchTexts="clientUsesEnglishAndFrenchTranslations()"
            ></CloseChatConfirmationModal>
            <div class="container no-margin" v-if="showFullChat" ref="chatHolder">
              <transition-group name="message-list" tag="div" v-bind:css="false" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter" appear>
                <li ref="message" v-for="m in messages" v-bind:key="m.priority" v-bind:data-index="m.priority">
                  <div v-if="m.showNameTimestamp" :key="m.index" :class="{'userBlurb': m.type == 'user', 'botBlurb': m.type == 'bot', 'buttonBlurb': m.type == 'button'}">
                    {{ m.messageName }} {{ m.time }}
                  </div>
                  <div :class="{'userMessage': m.type == 'user', 'botMessage': m.type == 'bot', 'buttonMessage': m.type == 'button'}">
                    <transition name="fade" mode="out-in">
                      <div v-if="!m.showDots">
                        <p :class="{'msgUser': m.type == 'user', 'msgBot': m.type == 'bot', 'msgButton': m.type == 'button'}" v-html="m.message"></p>
                        <img :src="m.mapsImg" class="googleMapsImg" v-show="m.mapsImg != ''" v-on:click="openGoogleMaps(m.onClickGoogleUrl)"/>
                        <div class="buttonHolder" v-for="choice in m.choices" v-bind:key="choice.index">
                          <button v-bind:class="checkForPadding(choice)" v-on:click="sendChoice(choice.choiceContent)" v-html="processContent(choice.choiceContent)"></button>
                        </div>
                      </div>
                      <div v-else class="dotHolder">
                        <div class="dot1"></div>
                        <div class="dot2"></div>
                        <div class="dot3"></div>
                      </div>
                    </transition>
                  </div>
                </li>
              </transition-group>
            </div>
          </div>
          <!--div class="row" v-if="showFullChat">
            <div class="col nopadding">
              <button class="staticButton">Skip Question</button>
            </div>
            <div class="col nopadding">
              <button class="staticButton col-md-12 text-left">Book now</button>
            </div>
            <div class="col-md-4 nopadding">
              <button class="staticButton">{{ this.firstName }}'s Profile</button>
            </div>
            <div class="profileBlurb" v-show="showProfileBlurb" v-on:click="showProfileBlurb = !showProfileBlurb">I auto generate a profile for you as you share information! Click here to view or edit your profile.</div>
          </div-->
          <div class="inputWithImage" v-if="showFullChat && canSendMessages">
            <input class="userInput" v-bind:disabled="submitNewMessageDisabled" v-model="query" @keyup.enter="submitMessage()" :placeholder="getTypeboxPlaceholder()" type="text" maxlength="256">
            <img alt="Send message" :src="arrow" tabindex="0" @mouseover="arrow=require('../assets/Arrow_hover.png')" @mouseleave="arrow=require('../assets/Arrow.png')" @click="submitMessage()" v-on:keyup.enter="submitMessage()" class="arrowButton" width="25" height="25"/>
          </div>
          <div class="footer" v-if="!showFullChat">
            <p class="footerBlurb">
              <a :href="footerBlurb.terms.link" target="_blank">
                {{ footerBlurb.terms.title }}
              </a>
              <a :href="footerBlurb.privacy.link" target="_blank">
                {{ footerBlurb.privacy.title }}
              </a>
            </p>
            <div class="poweredBlurb">
              <a href="https://www.leadmanaging.com" target="_blank">
                <img src="../assets/PVChatbotFooter.png" width="150" height="42"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButton from './CloseButton.vue'
import IntroForm from './IntroForm.vue'
import axios from 'axios'
import moment from 'moment'
import Velocity from 'velocity-animate'
import qs from 'qs'
import { conversationStateManager } from '../state/ConversationStateManager'
import { customEventsBus } from '../helpers/CustomEventsBus'
import CloseChatConfirmationModal from './CloseChatConfirmationModal.vue'

let sessionId = null
const apiUrl = '/api/'
const language = 'en-US'

const bookingUrlFragment = '.leadmanaging.com/application/controllers/booking.php?r='

export default {
  name: 'LandingPage',

  components: {
    'CloseButton': CloseButton,
    'IntroForm': IntroForm,
    'CloseChatConfirmationModal': CloseChatConfirmationModal
  },

  data () {
    return {
      showChatbot: true,
      showFullChat: false,
      showChatButton: true,
      showIntro: true,
      showBubble: true,
      canSendMessages: true,
      title: 'ChatManaging',
      introText: 'Hey! Please let me know your name and email, and I would be happy to have a quick chat. 😃 ',
      introTextEnglishFrench: 'Faites-moi part de votre nom et de votre adresse électronique, et je serai heureux d\'avoir une discussion rapide. 😃 <br><br> Hey! Please let me know your name and email, and I would be happy to have a quick chat. 😃',
      subject: 'Your ChatManaging conversation',
      close: 'X',
      firstName: 'N/A',
      lastName: 'N/A',
      email: 'N/A',
      staffEmail: [],
      escalationEmail: [],
      bookNow: '',
      messages: [],
      query: '',
      grabProfile: 'profile',
      saveQuery: '',
      showMessage: true,
      currentTime: null,
      arrow: require('../assets/Arrow.png'),
      botName: 'ChatManaging',
      footerBlurb: {
        terms: {
          title: 'Terms of Service',
          link: 'https://www.leadmanaging.com/terms-of-use'
        },
        privacy: {
          title: 'Privacy Policy',
          link: 'https://www.leadmanaging.com/privacy-policy'
        }
      },
      poweredBy: 'Powered by',
      delayFactorOne: 500,
      delayFactorTwo: 7,
      highestPriority: 0,
      priorityOne: 1,
      priorityTwo: 6,
      priorityThree: 11,
      countArray: 0,
      client: null,
      clientName: null,
      building: null,
      showProfileBlurb: true,
      bubbleCta: 'Hi! If you\'re interested in renting with us, have questions about availability, or want to book a viewing, I\'m happy to help! 😊',
      phone: 'N/A',
      unitType: 'N/A',
      moveIn: 'N/A',
      budget: 'N/A',
      apptDate: 'N/A',
      todaysDate: '',
      source: '',
      queryUrl: '',
      geocode1: 'https://maps.googleapis.com/maps/api/geocode/json?address=',
      geocode2: '&key=AIzaSyBXObwQidAhaTjru2U8Xhxetrkr-H7lkXE',
      latitude: '',
      longitude: '',
      staticMap1: 'https://maps.googleapis.com/maps/api/staticmap?center=',
      staticMap2: '&markers=icon:http://virtualresults.ca/chatbot/newpointer.png|',
      staticMap3: '&zoom=17&size=300x300&maptype=roadmap&key=AIzaSyBXObwQidAhaTjru2U8Xhxetrkr-H7lkXE',
      tag: '',
      submitDisabled: false,
      showCloseConfirmationModal: false,
      referer: '',
      utmUrl: '',
      isMobile: false,
      leadId: null,
      submitNewMessageDisabled: false,
    }
  },

  created () {
    window.addEventListener('beforeunload', this.handler)
  },

  methods: {
    clientUsesEnglishAndFrenchTranslations() {
      if (!this.client) {
        return false
      }

      return ['centurionqc', 'themarq', 'gwlraresidentialfr', 'cogirqc', 'metcapslqc', 'oxfordqc', 'oxfordpropertiesqc', 'bentallgreenoakqc', 'sandbox'].indexOf(this.client.replace('.csv', '')) > -1
    },

    getIntroText() {
      return this.clientUsesEnglishAndFrenchTranslations() ? this.introTextEnglishFrench : this.introText
    },

    getCopyConversationText() {
      return this.clientUsesEnglishAndFrenchTranslations()
        ? 'Envoyez vous une copie de cette conversation / Send yourself a copy of this conversation'
        : 'Send yourself a copy of this conversation'
    },

    getCopyConversationButtonLabel() {
      return this.clientUsesEnglishAndFrenchTranslations()
        ? 'Envoyer / Send'
        : 'Send'
    },

    getProvidedContactInfoMessageText() {
      return this.clientUsesEnglishAndFrenchTranslations()
        ? 'Informations de contact fournies / Provided contact info'
        : 'Provided contact info'
    },

    getButtonReplyText() {
      return this.clientUsesEnglishAndFrenchTranslations()
        ? 'Vous avez choisi / You chose:'
        : 'You chose: '
    },

    getEmailSentSuccessfullyMessageText() {
      return this.clientUsesEnglishAndFrenchTranslations()
        ? 'Email envoyé avec succès / Email sent successfully'
        : 'Email sent successfully'
    },

    getTypeboxPlaceholder() {
      return this.clientUsesEnglishAndFrenchTranslations()
        ? 'Composer votre message / Type here ...'
        : 'Type here...'
    },

    getConversationEndedText() {
      return this.clientUsesEnglishAndFrenchTranslations()
        ? 'La conversation est terminée / This conversation ended'
        : 'This conversation ended'
    },

    checkForPadding(choice) {
      if (choice.choiceContent.includes("Request an Appointment") || choice.choiceContent.includes("Tenant Request") || choice.choiceContent.includes("a href")) {
        return 'choiceNoPadding'
      }

      else {
        return 'choice'
      }
    },

    openGoogleMaps (url) {
      window.open(url, '_blank');
    },

    createEmail () {
      var headers = {
        'Authorization': process.env.VUE_APP_SENDGRID_API_KEY,
        'Content-Type': 'application/json'
      }

      // We are going to create the "log" of messages, plus timestamp and who wrote the message
      let i = 0
      let j = 0
      let log = ''
      for (i = 0; i < this.messages.length; i++) {
        log = log + this.messages[i].messageName + ' at  ' + this.messages[i].time + '<br>' + this.messages[i].message + '<br>'

        for (j = 0; j < this.messages[i].choices.length; j++) {
          log = log + '- ' + this.messages[i].choices[j].choiceContent + '<br>'
        }
        log = log + '<hr><br>'
      }

      let callApi = apiUrl + 'sendmail?firstName=' + this.firstName + '&lastName=' + this.lastName + '&subject=' + this.subject + '&email=' + this.email + '&building=' + this.$route.query.building + '&log=' + log

      axios.get(callApi, {headers: headers})
        .then(response => {
          console.log('response ------> ', response)
        }).catch(function (error) {
          console.log(error)
        })

      this.currentTime = moment().format('LT')
      this.addToMessages(this.firstName, this.currentTime, this.getEmailSentSuccessfullyMessageText(), 'button', false, true, false, this.highestPriority, [], '', '')
    },

    callTimerApi (timerApi) {
      axios.get(timerApi).then(response => {
      }).catch(function (error) {
        console.log(error)
      })
    },

    addMessageApi (messageApi) {
      axios.get(messageApi).then(response => {
      }).catch(function (error) {
        console.log(error)
      })
    },

    getApiResults (callApi) {
      axios.get(callApi).then(response => {
        response = response.data
        let numReplies = response.queryResult.fulfillmentMessages.length
        let i = 0
        let count = 1
        let holdChoices = []
        let mapsImageUrl = ''
        let onClickGoogleUrl = ''

        // Check whether we need to send an escalation email
        if (response.queryResult.intent.displayName === 'AskForHelp - By Email') {
          this.sendEscalation()
        }

        else if (response.queryResult.intent.displayName === 'AskForHelp - By Phone - Got Number') {
          if (this.phone === 'N/A') {
            this.logPhoneNumber(response.queryResult.parameters.fields.PhoneNumber.stringValue)
          }
          this.sendEscalation()
        }

        // Check whether we need to set the unit type
        else if (response.queryResult.intent.displayName === 'GotUnit' || response.queryResult.intent.displayName === 'GiveUnitType' || response.queryResult.intent.displayName === 'AskIfUnitAvail' || response.queryResult.intent.displayName === 'PricingExact') {
          // We got the prospect's preferred unit, so we need to save this into the temp log file.
          if (this.unitType === 'N/A') {
            this.logUnitType(response.queryResult.parameters.fields.UnitType.listValue.values[0].stringValue)
          }
        }

        else if (response.queryResult.intent.displayName === 'GotBudget') {
          if (response.queryResult.parameters.fields["unit-currency"].kind == 'stringValue' && response.queryResult.parameters.fields["unit-currency"].stringValue != '') {
            if (this.budget === 'N/A') {
              this.logBudget(response.queryResult.parameters.fields["unit-currency"].stringValue)
            }
          }

          else if (response.queryResult.parameters.fields["unit-currency"].kind == 'structValue') {
            if (this.budget === 'N/A') {
              this.logBudget(response.queryResult.parameters.fields["unit-currency"].structValue.fields.amount.numberValue)
            }
          }

          else if (response.queryResult.parameters.fields.number.kind == 'stringValue' && response.queryResult.parameters.fields.number.stringValue != '') {
            if (this.budget === 'N/A') {
              this.logBudget(response.queryResult.parameters.fields.number.stringValue)
            }
          }

          else if (response.queryResult.parameters.fields.number.kind == 'numberValue') {
            if (this.budget === 'N/A') {
              this.logBudget(response.queryResult.parameters.fields.number.numberValue)
            }
          }
        }

        else if (response.queryResult.intent.displayName === 'GotDate') {
          if (this.moveIn === 'N/A') {
            this.logMoveInDate(response.queryResult.parameters.fields.date.stringValue.split("T")[0])
          }
        }

        else if (response.queryResult.intent.displayName === 'GotDatePeriod') {
          if (this.moveIn === 'N/A') {
            this.logMoveInDate(response.queryResult.parameters.fields["date-period"].structValue.fields.startDate.stringValue.slice(0, 10))
          }
        }

        else if (response.queryResult.intent.displayName === 'GotAnyDate') {
          if (this.moveIn === 'N/A') {
            this.logMoveInDate('Any')
          }
        }

        else if (response.queryResult.intent.displayName === 'MoveInASAP') {
          if (this.moveIn === 'N/A') {
            this.logMoveInDate('ASAP')
          }
        }

        else if (response.queryResult.intent.displayName === 'SearchNearby') {
          // We need to invoke the Google Maps API
          // First, break apart based on the delimiter "(addrbreak)"
          let splitAddress = response.queryResult.fulfillmentMessages[0].text.text[0].split('(addrbreak)')
          let address = splitAddress[1]

          mapsImageUrl = this.staticMap1 + address + this.staticMap2 + address + this.staticMap3

          let pointOfInterest = response.queryResult.parameters.fields.PointOfInterest.stringValue
          // Check whether they asked for a 'keyword' (ie. are there restaurants nearby?)
          // If this keyword is empty (ie. they asked 'what is nearby?') we just show a generic map, otherwise we need to add markers
          // Get rid of the (addrbreak) in the response
          if (pointOfInterest === '') {
            response.queryResult.fulfillmentMessages[0].text.text[0] = splitAddress[0] + " Click on the map below to see any nearby points of interest!"
            onClickGoogleUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(address)
          }

          else {
            if (pointOfInterest == 'bakery' || pointOfInterest == 'library') {
              response.queryResult.fulfillmentMessages[0].text.text[0] = splitAddress[0] + " Click on the map below to enlarge it and see any bakeries that are nearby!'"
              onClickGoogleUrl = 'https://www.google.com/maps/search/?api=1&query=' + pointOfInterest + ' near ' + encodeURI(address)
            }

            else {
              response.queryResult.fulfillmentMessages[0].text.text[0] = splitAddress[0] + " Click on the map below to enlarge it and see any " + pointOfInterest + "s that are nearby!"
              onClickGoogleUrl = 'https://www.google.com/maps/search/?api=1&query=' + pointOfInterest + 's near ' + encodeURI(address)
            }
          }
        }

        // If the response is from a webhook, we will have to break it up into different messages
        // First, split up the messages based on the string "(msgbreak)", which is the designated delimiter
        if (response.queryResult.webhookSource === 'webhook') {
          var arrayOfSplitReplies = response.queryResult.fulfillmentMessages[0].text.text[0].split('(msgbreak)')

          // Now push each of these split messages into messages array
          var numSplitReplies = arrayOfSplitReplies.length
          for (i = 0; i < numSplitReplies; i++) {
            // While we are considering each message, we must check for any buttons and if they exist, further break it into clickable messages
            var containsButtons = arrayOfSplitReplies[i].includes('(spacebreak)')

            // If there were actually some buttons in this message...
            if (containsButtons) {
              // ...push each one into the choices array.
              // First split by spacebreak
              var splitIntoTwo = arrayOfSplitReplies[i].split('(spacebreak)')
              var buttons = splitIntoTwo[1].split('(btnbreak)')
              for (i = 0; i < buttons.length; i++) {
                // As long as the string is not empty
                if (buttons[i] !== '') {
                  // Add utm parameters for the booking link
                  if (buttons[i].includes(bookingUrlFragment)) {
                    const querytext = this.utmUrl ? `utm_url=${this.utmUrl}` : ''
                    if (querytext) {
                      buttons[i] = buttons[i].replace('href=\"([^\s]+)\"', `href=\"$1&${querytext}\"`)
                    }
                  }

                  holdChoices.push({ choiceContent: buttons[i] })
                }
              }
              let flagNameTimestamp = true
              this.addToMessages(this.botName, this.currentTime, splitIntoTwo[0], 'bot', false, flagNameTimestamp, true, count, holdChoices, mapsImageUrl, onClickGoogleUrl)
              count = count + 2
            } else {
              this.currentTime = moment().format('LT')
              let flagNameTimestamp = false

              if (i === 0) {
                flagNameTimestamp = true
              }

              // Add referer & utm parameters for the booking link
              if (arrayOfSplitReplies[i].includes(bookingUrlFragment)) {
                const querytext = this.utmUrl ? `utm_url=${this.utmUrl}` : (this.referer ? `referer=${this.referer}` : '')
                if (querytext) {
                  arrayOfSplitReplies[i] = arrayOfSplitReplies[i].replace('href=\"([^\s]+)\"', `href=\"$1&${querytext}\"`)
                }
              }
              this.addToMessages(this.botName, this.currentTime, arrayOfSplitReplies[i], 'bot', false, flagNameTimestamp, true, count, [], mapsImageUrl, onClickGoogleUrl)
              count = count + 2
            }
          }
        } else {
          // If it's not from a webhook, the replies will already be broken up. But we have to check for buttons.
          for (i = 0; i < numReplies; i++) {
            this.currentTime = moment().format('LT')
            let flagNameTimestamp = false

            if (i === 0) {
              flagNameTimestamp = true
            }

            this.addToMessages(this.botName, this.currentTime, this.getMessageTextForIntent(response.queryResult.fulfillmentMessages[i].text.text[0], response.queryResult.intent.displayName), 'bot', false, flagNameTimestamp, true, count, [], '', '')
            count = count + 2
          }
        }
      }).catch(function (error) {
        console.log(error)
      })
    },

    getMessageTextForIntent(message, intent) {
      if (!intent) {
        return message
      }

      const texts = {
        'AskForHelp - By Phone': 'Alright! What\'s your phone number?',
        'AskForHelp - By Phone - Got Number': 'Alright, one of our representatives will be in touch with you soon. Have a wonderful day! 😊',
        'AskForHelp - By Email': 'Alright, one of our representatives will send an email to the one you provided as soon as possible. Have a great day! 😊'
      }

      const textsWithFrench = {
        'AskForHelp - By Phone': 'C\'est bon! Quel est ton numéro de téléphone? / Alright! What\'s your phone number?',
        'AskForHelp - By Phone - Got Number': 'D\'accord, un de nos représentants vous contactera bientôt. Passez une excellente journée! / Alright, one of our representatives will be in touch with you soon. Have a wonderful day! 😊',
        'AskForHelp - By Email': 'D\'accord, un de nos représentants vous enverra un courriel à celui que vous avez fourni dès que possible. Passez une bonne journée! / Alright, one of our representatives will send an email to the one you provided as soon as possible. Have a great day! 😊'
      }

      if (texts.hasOwnProperty(intent)) {
        message = texts[intent]
      }

      if (this.clientUsesEnglishAndFrenchTranslations() && textsWithFrench.hasOwnProperty(intent)) {
        message = textsWithFrench[intent]
      }

      return message
    },

    logUnitType(unitType) {
      // We got their preferred unit, so write this to the temp file
      let unitTypeApi = apiUrl + 'logUnitType?unit=' + unitType + '&sessionId=' + sessionId + '&client=' + this.clientName + '&todaysdate=' + this.todaysDate

      this.unitType = unitType

      axios.get(unitTypeApi).then(response => {
      }).catch(function (error) {
        console.log(error)
      })
    },

    logBudget(budget) {
      // We got their preferred budget, so write this to the temp file
      let budgetApi = apiUrl + 'logBudget?budget=' + budget + '&sessionId=' + sessionId + '&client=' + this.clientName + '&todaysdate=' + this.todaysDate

      this.budget = budget

      axios.get(budgetApi).then(response => {
      }).catch(function (error) {
        console.log(error)
      })
    },

    logPhoneNumber(phoneNumber) {
      let phoneNumberApi = apiUrl + 'logPhoneNumber?phone=' + phoneNumber + '&sessionId=' + sessionId + '&client=' + this.clientName + '&todaysdate=' + this.todaysDate

      this.phoneNumber = phoneNumber

      axios.get(phoneNumberApi).then(response => {
      }).catch(function (error) {
        console.log(error)
      })
    },

    logMoveInDate(moveInDate) {
      let moveInApi = apiUrl + 'logMoveInDate?date=' + moveInDate + '&sessionId=' + sessionId + '&client=' + this.clientName + '&todaysdate=' + this.todaysDate

      this.moveIn = moveInDate

      axios.get(moveInApi).then(response => {
      }).catch(function (error) {
        console.log(error)
      })
    },

    sendEscalation () {
      if (this.staffEmail === '') {
        return
      }

      var headers = {
        'Content-Type': 'application/json'
      }

      // We are going to create the "log" of messages, plus timestamp and who wrote the message
      let i = 0
      let j = 0
      let log = ''
      for (i = 0; i < this.messages.length; i++) {
        log = log + this.messages[i].messageName + ' at  ' + this.messages[i].time + '<br>' + this.messages[i].message + '<br>'

        for (j = 0; j < this.messages[i].choices.length; j++) {
          log = log + '- ' + this.messages[i].choices[j].choiceContent + '<br>'
        }
        log = log + '<hr><br>'
      }

      const params = {
        sessionId: sessionId,
        langCode: language,
        query: this.grabProfile
      };
      let callParameterApi = apiUrl + 'detect?' + (new URLSearchParams(params).toString())

      axios.get(callParameterApi)
        .then((response) => {
          // Piece together the URL
          let callApi = apiUrl + 'sendescalation?firstName=' + this.firstName + '&lastName=' + this.lastName + '&email=' + this.email + '&staffemail=' + this.escalationEmail

          if (response.data.queryResult.parameters.fields.PhoneNumber.stringValue != '') {
            callApi = callApi + '&phone=' + response.data.queryResult.parameters.fields.PhoneNumber.stringValue
          }

          else {
            callApi = callApi + '&phone=N/A'
          }

          if (response.data.queryResult.parameters.fields.UnitType.listValue.values.length != 0) {
            callApi = callApi + '&unittype=' + response.data.queryResult.parameters.fields.UnitType.listValue.values[0].stringValue
          }

          else {
            callApi = callApi + '&unittype=' + 'N/A'
          }

          if (response.data.queryResult.parameters.fields.date.stringValue != '') {
            if (response.data.queryResult.parameters.fields.date.stringValue === 'today') {
              callApi = callApi + '&movein=Any'
            }

            else {
              callApi = callApi + '&movein=' + response.data.queryResult.parameters.fields.date.stringValue.split("T")[0]
            }
          }

          else if (response.data.queryResult.parameters.fields["date-period"].stringValue != '') {
            callApi = callApi + '&movein=' + response.data.queryResult.parameters.fields["date-period"].structValue.fields.startDate.stringValue.slice(0, 10)
          }

          else if (response.data.queryResult.parameters.fields.CheckMoveInASAP.stringValue != '') {
            callApi = callApi + '&movein=' + 'ASAP'
          }

          else {
            callApi = callApi + '&movein=' + 'N/A'
          }

	 if (response.data.queryResult.parameters.fields["unit-currency"].kind == 'stringValue') {
            if (response.data.queryResult.parameters.fields["unit-currency"].stringValue != '') {
              callApi = callApi + '&budget=' + response.data.queryResult.parameters.fields["unit-currency"].stringValue
            }

            else {
              callApi = callApi + '&budget=' + 'N/A'
            }
          }

          else if (response.data.queryResult.parameters.fields["unit-currency"].kind == 'structValue') {
            if (response.data.queryResult.parameters.fields["unit-currency"].structValue.fields.amount.numberValue != '') {
              callApi = callApi + '&budget=' + response.data.queryResult.parameters.fields["unit-currency"].structValue.fields.amount.numberValue
            }

            else {
              callApi = callApi + '&budget=' + 'N/A'
            }
          }

          else if (response.data.queryResult.parameters.fields.number.stringValue != '') {
            callApi = callApi + '&budget=' + response.data.queryResult.parameters.fields.number.numberValue
          }

          else {
            callApi = callApi + '&budget=' + 'N/A'
          }

          callApi = callApi + '&apptdate=' + this.apptDate + '&log=' + log
          return axios.get(callApi)
        })
        .then((response) => {
          console.log('response -----> ', response)
        })
    },

    addToMessages (inputName, inputTime, inputMessage, inputType, inputCheckmark, inputTimestamp, inputDots, inputPriority, inputChoices, inputMapsImg, inputGoogleUrl) {
      const messageData = {
        messageName: inputName,
        time: inputTime,
        message: inputMessage,
        type: inputType,
        showSecondCheckmark: inputCheckmark,
        showNameTimestamp: inputTimestamp,
        showDots: inputDots,
        priority: inputPriority,
        choices: inputChoices,
        mapsImg: inputMapsImg,
        onClickGoogleUrl: inputGoogleUrl
      }

      this.messages.push(messageData)

      // Now, call an API to add this message onto the file stored on our server
      let messageApi = apiUrl + 'addmessage?' + 'sessionId=' + sessionId + '&client=' + this.clientName + '&todaysdate=' + this.todaysDate + '&name=' + inputName + '&time=' + inputTime + '&message=' + inputMessage + '&choices='

      // Add the choices
      if (inputChoices != '') {
        let i = 0;
        for (i = 0; i < inputChoices.length; i++) {
          messageApi = messageApi + inputChoices[i].choiceContent + '(break)';
        }
      }

      messageApi = `${messageApi}&uiSpecificData=` + encodeURIComponent(JSON.stringify(messageData))

      this.addMessageApi(messageApi)

      this.scrollToBottom()
    },

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.height = 0
    },

    enter (el, done) {
      var delay = el.dataset.index * this.delayFactorOne
      var animationLength = el.innerHTML.length * this.delayFactorTwo

      setTimeout(function () {
        Velocity(
          el,
          { opacity: 1, height: '100%' },
          { duration: animationLength, easing: [ 0.17, 0.27, 0.04, 0.88 ], complete: done })
      }, delay)
    },

    afterEnter (el) {
      // not sure what's the purpose of this, addressing some error effect for now
      if (this.countArray >= this.messages.length) {
        return
      }

      this.messages[this.countArray].showDots = false
      this.countArray++
    },

    async onSubmit (chatFlag, introFlag, firstName, lastName, email) {
      if (this.submitDisabled) {
        return
      }

      this.submitDisabled = true
      try {
        sessionId = conversationStateManager.initConversation()

        const params = {
          langCode: language,
          client: this.clientName,
          tag: this.tag,
          contentSource: this.contentSource,
          contentSourceData: this.contentSourceData || {},
          userData: {
            firstName: firstName,
            lastName: lastName,
            email: email,
            useEnglishAndFrenchTexts: this.clientUsesEnglishAndFrenchTranslations(),
          },
        }

        if (this.utmUrl) {
          params.utmUrl = this.utmUrl
        } else {
          params.referer = this.referer
        }

        const response = await axios.post(
          `${apiUrl}conversations/${sessionId}/init`,
          { ...params }
        )

        if (response.data.data) {
          this.leadId = response.data.data.conversation.user_data.leadId
        }

        this.listenForConversationUpdates()
      } catch (e) {}
      this.submitDisabled = false

      // Save the contact details
      this.canSendMessages = true
      this.submitNewMessageDisabled = false

      this.showFullChat = chatFlag
      this.showIntro = introFlag
      this.firstName = firstName
      this.lastName = lastName
      this.email = email
      this.showChatButton = false
      this.currentTime = moment().format('LT')

      this.addToMessages(this.firstName, this.currentTime, this.getProvidedContactInfoMessageText(), 'button', false, true, false, this.highestPriority, [], '', '')

      // Send the name of the config file it will read from, then (break), then the building name
      const params = {
        sessionId: sessionId,
        langCode: language,
        query: this.client + '(break)' + this.tag,
      };
      let callApi = apiUrl + 'detect?' + qs.stringify(params)

      this.getApiResults(callApi)

      // Call an API for the timer to mark the start of the conversation and create a conversation log file which has the name of the session ID
      let timerApi = apiUrl + 'starttimer?' + 'sessionId=' + sessionId + '&client=' + this.clientName + '&todaysdate=' + this.todaysDate + '&firstName=' + this.firstName + '&lastName=' + this.lastName + '&email=' + this.email + '&staffemail=' + this.staffEmail + '&phone=' + this.phone + '&unittype=' + this.unitType + '&movein=' + this.moveIn + '&budget=' + this.budget + '&apptdate=' + this.apptDate
      this.callTimerApi(timerApi)
    },

    scrollToBottom () {
      this.$refs.scrollBox.scrollTop = this.$refs.scrollBox.scrollHeight
    },

    submitMessage () {
      if (this.submitNewMessageDisabled) {
        return
      }

      if (!this.query) {
        return
      }

      this.submitNewMessageDisabled = true

      this.loadExistingConversationData(sessionId).then((responseData) => {
        if (!responseData.conversation) {
          return
        }

        if (responseData.conversation.status === 'ended') {
          this.canSendMessages = false
          this.appendConversationEndedMessage()

          return
        }

        this.submitNewMessageDisabled = false

        this.currentTime = moment().format('LT')

        // Save the user's message(s) into messages
        this.addToMessages(this.firstName, this.currentTime, this.query, 'user', false, true, false, this.highestPriority, [], '', '')

        this.saveQuery = this.query
        this.query = ''

        // setTimeout(function () {
        //   this.messages[this.messages.length - 1].showSecondCheckmark = true
        // }.bind(this), this.delayFactor)

        const params = {
          sessionId: sessionId,
          langCode: language,
          query: this.saveQuery
        };
        let callApi = apiUrl + 'detect?' + (new URLSearchParams(params).toString())

        // Call the api with the url
        this.getApiResults(callApi)
      }).catch(() => {
        this.submitNewMessageDisabled = false
      })
    },

    sendChoice (choiceContent) {
      this.currentTime = moment().format('LT')

      // Check if we have the "request an appointment" branch, which means we need to extract the phrase and discard the HTML code
      if (choiceContent.includes("Request an Appointment")) {
        choiceContent = 'Request an Appointment'
      }

      if (choiceContent.includes("Tenant Request")) {
        choiceContent = 'Tenant Request'
      }

      else if (choiceContent.includes("<a href")) {
        // If the content contains a link, this is likely for the virtual tour button. We want to strip that out otherwise the unit they select will not properly appear in the email details.
        var arr = choiceContent.split('</a')
        var arr2 = arr[0].split('>')
        choiceContent = arr2[1]
      }

      let fullButtonReply = this.getButtonReplyText() + choiceContent
      // The user has clicked on a button. We must append this to our messages list as a user's message.
      this.addToMessages(this.firstName, this.currentTime, fullButtonReply, 'button', false, true, false, this.highestPriority, [], '', '')

      // Now create the api url and call get
      const params = {
        sessionId: sessionId,
        langCode: language,
        query: choiceContent
      };
      let callApi = apiUrl + 'detect?' + (new URLSearchParams(params).toString())
      this.getApiResults(callApi)
    },

    async grabEmails(url) {
      try {
        // fetch data from a url endpoint
        const data = await axios.get(url);

	if (data.data.emails.length === 0) {
		this.staffEmail = ['darren@comflo.io'];
		this.escalationEmail = ['darren@comflo.io'];
	}

	else {
		this.staffEmail = data.data.emails[0].notification_email;
		this.escalationEmail = data.data.emails[0].escalation_email;
	}
      } catch(error) {
        //console.log("error", error);
        // appropriately handle the error
      }
    },

    setVariables () {
      let varApi = apiUrl + 'getemail?' + 'client=' + this.$route.query.client + '&tag=' + this.$route.query.tag
      this.grabEmails(varApi)
    },

    endConversation () {
      this.showCloseConfirmationModal = false
      this.showFullChat = false
      this.showIntro = true

      sessionId = null
      this.messages.splice(0)
      this.countArray = 0

      conversationStateManager.clearConversation()
      customEventsBus.emitEvent({
        type: 'pvChatbotHideChat'
      })
    },
    hideCloseConfirmationModal () {
      this.showCloseConfirmationModal = false
      this.showFullChat = true
    },

    processContent (content) {
      if (!URL) {
        return
      }

      const urlRegex = /(https?:\/\/[^ "]*)/

      const urls = content.match(urlRegex) || []

      urls.forEach((url) => {
        const enhancedUrl = new URL(url)
        if (this.referer) {
          enhancedUrl.searchParams.append('referer', this.referer)

          if (this.isMobile) {
            enhancedUrl.searchParams.append('showReturnButton', encodeURIComponent('Back to Chatbot'))
          }
        }

        if (this.leadId) {
          enhancedUrl.searchParams.append('li', this.leadId)
        }

        content = content.replace(url, enhancedUrl.toString())
      })

      if (this.isMobile) {
        content = content.replace(/target="_blank"/g, 'target="_parent"')
      }

      return content
    },

    async loadExistingConversationData(sessionId) {
      try {
        return axios.get(
          `${apiUrl}conversations/${sessionId}`
        ).then((response) => {
          if (!response.data) {
            return
          }

          return response.data.data
        })
      } catch (error) {
        return error
      }
    },

    async initExistingConversation(sessionId) {
      try {
        this.loadExistingConversationData(sessionId).then((responseData) => {
          const conversation = responseData.conversation
          const messages = responseData.messages

          if (!conversation) {
            return
          }

          if (conversation.user_data) {
            this.firstName = conversation.user_data.firstName
            this.lastName = conversation.user_data.lastName
            this.email = conversation.user_data.email
            this.leadId = conversation.user_data.leadId
            this.moveIn = conversation.user_data.moveInDate || 'N/A'
            this.phone = conversation.user_data.phone || 'N/A'
            this.unitType = conversation.user_data.unitType || 'N/A'
            this.budget = conversation.user_data.budget || 'N/A'
          }

          this.showFullChat = true
          this.showIntro = false
          this.showChatButton = false

          if (conversation.status === 'ended') {
            this.canSendMessages = false
            this.submitNewMessageDisabled = false
          } else {
            this.listenForConversationUpdates()
          }


          customEventsBus.emitEvent({
            type: 'pvChatbotShowChat',
            reason: 'existingConversation',
            conversationId: sessionId
          }, '*')

          setTimeout(() => {
            messages.forEach((message) => {
              this.messages.push(JSON.parse(decodeURIComponent(message.data.uiSpecificData)))
            })
          }, 1000)
        }).catch((error) => {
          if (error.response && error.response.status === 404) {
            conversationStateManager.clearConversation()
            sessionId = null
          }
        })
      } catch (e) {
      }
    },

    listenForConversationUpdates() {
      const interval = setInterval(() => {
        this.loadExistingConversationData(sessionId).then((responseData) => {
          const conversation = responseData.conversation
          const messages = responseData.messages

          if (!conversation) {
            return
          }

          if (conversation.status === 'ended') {
            this.canSendMessages = false
            clearInterval(interval)
            this.appendConversationEndedMessage()
          }
        })
      }, 10 * 1000)
    },

    appendConversationEndedMessage() {
      const conversationEndMessageExists = this.messages.filter((message) => message.data && message.data.conversationEndNotification).length

      if (conversationEndMessageExists) {
        return
      }

      const messageData = {
        messageName: this.botName,
        time: moment().format('LT'),
        message: this.getConversationEndedText(),
        type: 'bot',
        showSecondCheckmark: false,
        showNameTimestamp: true,
        showDots: true,
        priority: 1,
        choices: [],
        mapsImg: '',
        onClickGoogleUrl: '',
        data: {
          conversationEndNotification: true,
        }
      }

      this.messages.push(messageData)
    }
  },

  mounted () {
    this.scrollToBottom()
    this.clientName = this.$route.query.client
    this.tag = this.$route.query.tag
    this.referer = this.$route.query.hostPage || ''
    this.isMobile = this.$route.query.isMobile === 'true'

    const UTM_PARAMETERS = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content'
    ]
    let utmFound = false
    if (this.referer) {
      try {
        const urlQuery = (new URL(decodeURIComponent(this.referer))).searchParams

        for (const utmParam of UTM_PARAMETERS) {
          if (urlQuery.has(utmParam)) {
            utmFound = true
          }
        }
      } catch (e) {}
    }

    if (utmFound) {
      this.utmUrl = decodeURIComponent(this.referer)
    }

    sessionId = this.$route.query.conversationId

    if (sessionId) {
      this.initExistingConversation(sessionId)
    }

    this.contentSource = this.$route.query.contentSource || 'csv'

    if (this.contentSource === 'vista-crm') {
      this.contentSourceData = {
        vistaApiUrl: this.$route.query.contentApiUrl,
        websiteId: this.$route.query.websiteId
      }
    }

    if (this.contentSource === 'vista-crm-buildingfloorplans') {
      this.contentSourceData = {
        vistaApiUrl: this.$route.query.contentApiUrl,
        buildingId: this.$route.query.buildingId,
        pmcName: this.$route.query.pmcName
      }
    }

    if (typeof this.$route.query.client !== 'undefined') {
      this.client = this.$route.query.client + '.csv'
    }

    if (typeof this.$route.query.building !== 'undefined') {
      this.building = this.$route.query.building
    }

    if (typeof this.$route.query.source !== 'undefined') {
      this.source = this.$route.query.source
    }

    this.todaysDate = moment().format('YYYYMMDD')
    this.setVariables()

    customEventsBus.addEventListener('closeChat', () => {
      if (this.showFullChat) {
        if (!this.canSendMessages) {
          this.endConversation()
          return
        }

        this.showCloseConfirmationModal = true
        this.showFullChat = false

        return
      }

      customEventsBus.emitEvent({ type: 'pvChatbotHideChat' })
    })
  },

  updated () {
    this.$nextTick(this.scrollToBottom())
  }
}
</script>

<style scoped>
.chat {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}

.chat-window {
  position: absolute;
  top: 2px;
  right: 2px;
  bottom: 2px;
  left: 2px;
  display: block;
  float: right;
  padding: 20px
}

.wrapper {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}

.removePadding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.containerBox {
  z-index: 1;
  position: relative;
  overflow: hidden;
  display: block;
  float: right;
  -webkit-filter: drop-shadow(0px 0px 5px #d7d5d5);
  filter: drop-shadow(0px 0px 5px #d7d5d5);
  background-color: #FFFFFF;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  padding-right: 25px;
  padding-left: 25px;
  padding-top: 10px;
}

body {
  overflow: hidden;
  background: transparent !important;
  background-color: transparent !important;
}

.no-margin {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.header {
  position: relative;
  overflow: hidden;
  color: #0073bc;
  font-family: 'Bree Serif', serif;
  font-size: 22px;
}

.space {
  padding-top: 10px;
}

hr {
  border: 1px solid #f7f6f6;
  width: 100%;
  margin-bottom: 0;
  margin-top: 5px;
}

.botIcon {
  margin-top: 10px;
}

.title {
  font-size: 14px;
  font-family: "Arial";
  color: #0073bc;
  margin-top: 10px;
  display: inline-block;
}

.page-content {
  float: left;
  width: 100%;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  font-family: "Arial";
  font-size: 12px;
}

.inputWithImage {
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding-bottom: 10px;
}

.arrowButton {
  position: absolute;
  cursor: pointer;
  right: 80px;
  top: 10px;
}

.stickyFooter {
  flex: 0 0 auto;
}

.submitButton {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #0073bc;
  border: none;
  font-size: 14px;
  margin-bottom: 5px;
  margin-top: 1px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 20px;
}

.submitButton:hover {
  background-color: #3984b7;
}

.nopadding {
  padding: 8px 5px 8px 15px !important;
}

.staticButton {
  width: 100%;
  background-color: #FFFFFF;
  color: #0073bc;
  font-size: 12px;
  border: 1.5px #0073bc solid;
  cursor: pointer;
  border-radius: .25rem;
  padding-top: 5px;
  padding-bottom: 5px;
  font-weight: bold;
}

.profileBlurb {
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 0 6px #B2B2B2;
  display: inline-block;
  padding: 10px 18px;
  position: absolute;
  vertical-align: top;
  margin: 20px 10px;
  font-size: 12px;
  right: 15px;
  bottom: 140px;
  width: 150px;
  animation: fadeIn 6s linear;
}

.profileBlurb::before {
  background-color: #FFFFFF;
  content: "\00a0";
  display: block;
  height: 16px;
  width: 16px;
  position: absolute;
  bottom: -7.5px;
  transform: rotate(47deg) skew(5deg);
  -moz-transform: rotate(47deg) skew(5deg);
  -ms-transform: rotate(47deg) skew(5deg);
  -o-transform: rotate(47deg) skew(5deg);
  -webkit-transform: rotate(47deg) skew(5deg);
  box-shadow: 2px 2px 2px 0 rgba( 178, 178, 178, .4 );
  animation: fadeIn 6s linear;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  86% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.staticButton:hover {
  background-color: #0073bc;
  color: #FFFFFF;
}

.userInput {
  min-height: 45px;
  border-radius: 7px;
  border: 1px solid #ced4da;
  font-size: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: calc(100% - 60px);
}

.userInput:focus {
  -webkit-box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
  -moz-box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
  box-shadow: 0px 0px 3px 1px rgba(215,213,213,1);
}

.footer {
  background: #FFFFFF;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding-bottom: 10px;
}

.footerBlurb {
  font-size: 10px;
  color: rgb(21, 94, 230);
  margin-bottom: 3px;
}
.footerBlurb a {
  color: rgb(0, 48, 107);
  font-weight: bold;
}
.footerBlurb a:not(:first-of-type) {
  padding-left: 5px;
  position: relative;
}
.footerBlurb a:not(:first-of-type):before {
  content: ' ';
  border-left: 1px solid #a0a0a0;
  position: absolute;
  height: 100%;
  left: 0;
}

.poweredBlurb {
  padding-right: 5px;
}

.table {
  font-family: "Arial";
  font-size: 12px;
  margin-bottom: 0px;
}

.table>tbody>tr>td,
.table>tbody>tr>th {
  border-top: none;
}

li {
  list-style: none;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.userMessage {
  background-color: #0073bc;
  color: #FFFFFF;
  border-radius: 7px;
  font-family: "Arial";
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  word-wrap: break-word;
  margin-left: 30px;
}

.botMessage {
  background-color: #f7f6f6;
  color: #2d2d2d;
  border-radius: 7px;
  font-family: "Arial";
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  word-wrap: break-word;
  margin-right: 30px;
}

.buttonMessage {
  background-color: #FFFFFF;
  font-size: 12px;
  font-family: "Arial";
  word-wrap: break-word;
  text-align: right;
  color: #0073bc;
}

.userBlurb {
  color: #a0a0a0;
  font-size: 10px;
  text-align: right;
  background-color: white;
}

.buttonBlurb {
  color: #a0a0a0;
  font-size: 10px;
  text-align: right;
  background-color: white;
}

.botBlurb {
  color: #a0a0a0;
  font-size: 10px;
  text-align: left;
  background-color: white;
}

.message-list-item {
  display: inline-block;
  margin-right: 10px;
}
.message-list-enter-active, .message-list-leave-active, .message-list-appear {
  transition: all 1.0s;
}
.message-list-enter, .message-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.dotHolder {
  text-align: center;
}

.dot1 {
  height: 12px;
  width: 12px;
  display: inline-block;
  background-color: #939393;
  border-radius: 50%;
  -webkit-animation: typing 1.3s infinite;
  -webkit-animation-delay: 0.0s;
  animation: typing 1.3s infinite;
  animation-delay: 0.0s;
}

.dot2 {
  height: 12px;
  width: 12px;
  background-color: #939393;
  border-radius: 50%;
  display: inline-block;
  -webkit-animation: typing 1.3s infinite;
  -webkit-animation-delay: 0.2s;
  animation: typing 1.3s infinite;
  animation-delay: 0.2s;
}

.dot3 {
  height: 12px;
  width: 12px;
  background-color: #939393;
  border-radius: 50%;
  display: inline-block;
  -webkit-animation: typing 1.3s infinite;
  -webkit-animation-delay: 0.3s;
  animation: typing 1.3s infinite;
  animation-delay: 0.3s;
}

@-webkit-keyframes typing {
  0% { opacity: 0; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes typing {
  0% { opacity: 0; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.googleMapsImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 70%;
  max-height: 60%;
  min-width: 100px;
  min-height: 100px;
  cursor: pointer;
  padding-top: 10px;
}

.choice >>> .darkLink {
  color: #2d2d2d;
  text-decoration: none;
}

.choice >>> .darkLink:hover {
  color: #2d2d2d;
  text-decoration: none;
}

.choiceNoPadding >>> .darkLink {
  color: #2d2d2d;
  text-decoration: none;
  display: block;
  padding: 5px 20px;
}

.choiceNoPadding >>> .darkLink:hover {
  color: #2d2d2d;
  text-decoration: none;
  display: block;
  padding: 5px 20px;
}

.msgBot {
  text-align: left;
  padding: 0;
  margin: 0;
}

.msgUser {
  text-align: right;
  padding: 0;
  margin: 0;
}

.msgButton {
  text-align: right;
  padding: 0;
  margin: 0;
}

.buttonHolder {
  display: inline-block;
  text-align: center;
  padding-top: 10px;
}

.choiceNoPadding {
  color: #2d2d2d;
  border-radius: 30px;
  border: 1px solid #2d2d2d;
  cursor: pointer;
  margin-left: 2px;
  margin-right: 2px;
  background-color: #f7f6f6;
  padding: 0;
}

.choice {
  color: #2d2d2d;
  border-radius: 30px;
  border: 1px solid #2d2d2d;
  padding: 5px 20px;
  cursor: pointer;
  margin-left: 2px;
  margin-right: 2px;
  background-color: #f7f6f6;
}

.choice:hover {
  background-color: #dedddd;
}

.choiceNoPadding:hover {
  background-color: #dedddd;
}

.msgBot >>> .darkBlueLink {
  color: #0073bc !important;
}

.msgBot >>> .darkBlueLink:hover {
  color: #3984b7 !important;
}

@media only screen and (max-width: 500px) {
  .title {
    font-size: 10px;
  }

  .submitButton {
    margin: 5px 0 5px;
    padding: 2px 12px;
    font-size: 12px;
  }

  .page-content {
    height: calc(100% - 90px);
  }

  .chat-window {
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    padding: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Bot2.vue